import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';

import { Box } from 'common/components/material';

import { getObjectiveStatusColor, OBJECTIVE_STATUS_LABELS } from '../objectives.constants';
import { ObjectiveStatusEnum } from '../objectives.enum';

type ObjectiveStatusChipProps = {
  status: ObjectiveStatusEnum;
};

const ObjectiveStatusChip: React.FC<ObjectiveStatusChipProps> = ({ status }) => {
  const { palette } = useTheme();
  const color = getObjectiveStatusColor(status, palette);

  return (
    <Box
      sx={{
        px: 1,
        py: 0.25,
        borderRadius: '999px',
        flexShrink: 0,
        fontSize: '0.625rem',
        fontWeight: 600,
        lineHeight: 1.6,
        whiteSpace: 'nowrap',
        backgroundColor: alpha(color, 0.16),
        color,
      }}
    >
      {OBJECTIVE_STATUS_LABELS[status]}
    </Box>
  );
};

export default ObjectiveStatusChip;
